module.exports = {
          srcSet: "/_next/static/images/outlook-calendar-48-6c3ed0490d75c9462d9831594701114f.webp"+" 48w",
          images:[ {path: "/_next/static/images/outlook-calendar-48-6c3ed0490d75c9462d9831594701114f.webp",width: 48,height: 48}],
          src: "/_next/static/images/outlook-calendar-48-6c3ed0490d75c9462d9831594701114f.webp",
          toString:function(){return "/_next/static/images/outlook-calendar-48-6c3ed0490d75c9462d9831594701114f.webp"},
          
          width: 48,
          height: 48
        }